import type { FormStatus, FormType } from "../types/forms";
import { toDateOnlyString } from "./dateOnly";

export const statusLabels: Record<FormStatus, string> = {
  pending: "Pending",
  under_review: "Under Review",
  approved: "Approved",
  credit_issued: "Credit Issued",
  rejected: "Rejected",
  cancelled: "Cancelled",
  scheduled: "Scheduled",
  completed: "Completed",
};
export const formTypeLabel = (type: FormType) =>
  type === "credit" ? "Credit Request" : "Demo Request";
export const today = () => toDateOnlyString(new Date())!;
export const formatFormTime = (value: string) =>
  new Date(value.includes("T") ? value : value.replace(" ", "T") + "Z").toLocaleString();
export const formActionLabels: Record<FormStatus, string> = {
  pending: "Pending",
  under_review: "Start Review",
  approved: "Approve",
  credit_issued: "Mark Credit Issued",
  rejected: "Reject",
  cancelled: "Cancel Request",
  scheduled: "Schedule Demo",
  completed: "Complete Demo",
};
export function formsQuery(params: URLSearchParams, customerId?: number): URLSearchParams {
  const query = new URLSearchParams();
  [
    "type",
    "status",
    "customer_id",
    "created_by",
    "date_from",
    "date_to",
    "search",
    "page",
    "sort",
    "direction",
  ].forEach((key) => {
    const value = params.get(key);
    if (value) query.set(key, value);
  });
  if (customerId) query.set("customer_id", String(customerId));
  query.set("per_page", "20");
  return query;
}
